import { routenames } from '@/router/routenames';
import type { I18nKey } from '@/utils/typings';
import type { NavigationEntryRaw } from '../types';

export const importedMeasurementsNavigationRaw: NavigationEntryRaw[] = [
  {
    titleI18n: 'ImportedMeasurements' as I18nKey,
    route: { name: routenames.importedMeasurements.index },
  },
];
